import React, { FC } from 'react';
import { Typography } from 'antd';
import { Consent } from '~/types';
import { useTranslation } from 'react-i18next';
import { AmountField } from '~/components';
import styled from 'styled-components';

interface ConsentDetailsProps {
  consent: Consent;
}

const ConsentDetailsContainer = styled.div`
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
`;

const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const LabelText = styled(Typography.Text)`
  color: #a1a0ae;
`;

const AmountText = styled(Typography.Text)`
  font-weight: 500;
`;

const ConsentDetails: FC<ConsentDetailsProps> = ({ consent }) => {
  const { t } = useTranslation('sendMoney');

  return (
    <ConsentDetailsContainer>
      <Typography.Title level={4}>{t('transactionDetails')}</Typography.Title>
      <DetailRow>
        <LabelText>{t('beneficiaryWillReceive')}</LabelText>
        <AmountText>
          <AmountField amount={consent?.beneficiaryAmount} />
        </AmountText>
      </DetailRow>
      {consent?.fees &&
        consent?.fees?.length > 0 &&
        consent?.fees?.map((fee, index) =>
          !fee?.amount ? null : (
            <DetailRow key={index}>
              <LabelText>{fee?.description}</LabelText>
              <AmountText>
                <AmountField amount={fee?.amount} />
              </AmountText>
            </DetailRow>
          )
        )}
      <DetailRow>
        <LabelText>{t('total')}</LabelText>
        <AmountText>
          <AmountField amount={consent?.totalAmount} />
        </AmountText>
      </DetailRow>
    </ConsentDetailsContainer>
  );
};

export default ConsentDetails;
